export function setNotificationRead(isRead) {
  return {
    type: '@notification/SET_READ',
    payload: { isRead },
  };
}
